/* LXRYWOOD – Raumteiler-Konfigurator (Block-Architektur).
   Alle Elemente werden relativ zum Root [data-rt-konfigurator] gesucht; die Reihenfolge der Blöcke ist frei.
   Jeder Block ist optional: fehlt ein Element (Range, Vorschau, Raumhöhe, CTA), wird es übersprungen. */
const Q=(r,s)=>r.querySelector(s),QA=(r,s)=>Array.from(r.querySelectorAll(s));
/* Rasterzellen n = (B + Fuge) / 80. Fuge war 50 mm (B = 80n - 50), ist seit 13.10.2026 52 mm (B = 80n - 52);
   (B + 51) / 80 rundet bei beiden Staenden exakt auf n. */
const LAM=mm=>Math.round((mm+51)/80),DE=n=>n.toFixed(1).replace('.',',');
const BEF={schrauben:'Schrauben',kleben:'Kleben'};
/* Altwerte aus frueheren Templates (winkel/direkt) auf 'kleben' abbilden */
const NK=v=>(v==='winkel'||v==='direkt')?'kleben':(v||'schrauben');
const pub=(ev,data)=>{if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS[ev],data);};
const fn=(name,...a)=>{const f=window[name];return typeof f==='function'?f(...a):undefined;};

class Rt{
constructor(root){
const d=root.dataset,h=Q(root,'[data-rt-hoehe]');
this.root=root;this.d=d;this.dlg=Q(root,'[data-rt-dialog]');
this.variants=JSON.parse(Q(root,'#rt-product-json').textContent).variants||[];
this.oO='option'+d.optOber;this.oB='option'+d.optBreite;
this.widths=[...new Set(this.variants.map(v=>v[this.oB]))].sort((a,b)=>a-b);
/* Bestell-Texte je Befestigungs-Block (data-label an den Buttons), Fallback: BEF */
this.bef={boden:{...BEF},decke:{...BEF}};
QA(root,'[data-rt-set="boden"],[data-rt-set="decke"]').forEach(b=>{if(b.dataset.label)this.bef[b.dataset.rtSet][b.dataset.value]=b.dataset.label;});
this.propName=k=>{const el=Q(root,'[data-rt-bef="'+k+'"]');return(el&&el.dataset.propName)||(k==='boden'?'Befestigung Boden':'Befestigung Decke');};
this.s={oberflaeche:null,breiteIndex:0,struktur:d.defaultStruktur,boden:NK(d.defaultBoden),decke:NK(d.defaultDecke),raumhoehe:h&&h.value?+h.value:null,check:null};
this.setVariant(this.fromUrl()||this.variants.find(v=>v.id==d.selectedVariant)||this.variants.find(v=>v.available)||this.variants[0]);
this.bind();this.render();
}
lab(k,v){v=NK(v);return(this.bef[k]&&this.bef[k][v])||BEF[v]||v;}
fromUrl(){const id=new URLSearchParams(location.search).get('variant');return id&&this.variants.find(v=>v.id==id);}
setVariant(v){if(!v)return;this.s.oberflaeche=v[this.oO];this.s.breiteIndex=Math.max(0,this.widths.indexOf(v[this.oB]));}
get breite(){return this.widths[this.s.breiteIndex];}
resolveVariant(){const s=this.s;return this.variants.find(v=>v[this.oO]===s.oberflaeche&&v[this.oB]===this.breite)||null;}
money(c){return fn('formatPriceAmount',c,this.d.currency)||(c/100).toLocaleString('de-DE',{style:'currency',currency:this.d.currency||'EUR'});}
bind(){
const r=this.root;
r.addEventListener('click',e=>{
const t=e.target,b=t.closest('[data-rt-set]');
if(b){this.s[b.dataset.rtSet]=b.dataset.rtSet==='struktur'?b.dataset.value:NK(b.dataset.value);return this.render();}
const o=t.closest('[data-rt-open-check]');if(o)return this.openCheck(o);
const om=t.closest('[data-rt-open-modal]');if(om){e.preventDefault();return this.openModal(om);}
const cm=t.closest('[data-rt-modal-close]');if(cm)return this.closeModal();
const ml=t.closest('[data-rt-mail]');if(ml)this.buildMail(ml);
const wa=t.closest('[data-rt-wa]');if(wa)this.buildWa(wa);
const a=t.closest('[data-rt-dlg]');if(a)return this.dialogAction(a.dataset.rtDlg);
if(t.closest('[data-rt-backdrop]'))this.closeCheck();
});
r.addEventListener('change',e=>{
const n=e.target.name;
if(this.dlg&&this.dlg.contains(e.target))this.markOpts();
if(n==='rt-oberflaeche'){this.s.oberflaeche=e.target.value;this.render();}else if(n==='rt-fbh')this.step(1);
});
r.addEventListener('input',e=>{
const t=e.target;
if('rtRange'in t.dataset){this.s.breiteIndex=+t.value;this.render();}
else if('rtSelect'in t.dataset){this.s.breiteIndex=Math.max(0,this.widths.indexOf(t.value));this.render();}
else if('rtHoehe'in t.dataset){this.s.raumhoehe=t.value===''?null:+t.value;t.removeAttribute('aria-invalid');this.render();}
});
r.addEventListener('keydown',e=>{if(e.key==='Escape'){this.closeCheck();this.closeModal();}});
const form=Q(r,'[data-rt-form]');if(form)form.addEventListener('submit',e=>{e.preventDefault();this.addToCart(e.submitter);});
addEventListener('popstate',()=>{const v=this.fromUrl();if(v){this.setVariant(v);this.render(false);}});
const main=Q(r,'[data-rt-cta-main]'),sticky=Q(r,'[data-rt-sticky]');
if(main&&sticky)new IntersectionObserver(en=>sticky.classList.toggle('is-visible',!en[0].isIntersecting)).observe(main);
}
/* Bauhoehe = kleinstes Raummass minus 5 mm Einbauluft (Schrauben wie Kleben) */
bauhoehe(h){return DE(h-0.5)+' cm';}
properties(){
const s=this.s,h=s.raumhoehe,p={};
if(Q(this.root,'[data-rt-set="struktur"]'))p['Struktur']=s.struktur;
p[this.propName('boden')]=this.lab('boden',s.boden);
p[this.propName('decke')]=this.lab('decke',s.decke);
Object.assign(p,{'Raumhöhe (kleinstes Maß)':h?h+' cm':'','Bauhöhe':h?this.bauhoehe(h):'','Lamellen':''+LAM(+this.breite),'Montage-Check':s.check?s.check.summary:'nicht durchgeführt'});
if(s.check)p._check_json=JSON.stringify(s.check);
/* Alle weiteren Formularfelder (Produkt-Optionen-Radios, Gratis-Zugaben, andere Bloecke mit form-Attribut) uebernehmen */
const form=Q(this.root,'[data-rt-form]');
if(form)Array.from(form.elements).forEach(el=>{
const m=/^properties\[(.+)\]$/.exec(el.name||'');if(!m||el.dataset.prop||el.disabled)return;
if((el.type==='radio'||el.type==='checkbox')&&!el.checked)return;
p[m[1]]=el.value;
});
return p;
}
render(pushUrl=true){
const r=this.root,s=this.s,d=this.d,v=this.resolveVariant();this.variant=v;
const ok=!!(v&&v.available),mm=+this.breite,cm=mm/10,n=LAM(mm);
QA(r,'input[name="rt-oberflaeche"]').forEach(i=>i.checked=i.value===s.oberflaeche);
const sw=Q(r,'input[name="rt-oberflaeche"]:checked');this.color=sw?.dataset.color||this.color;
QA(r,'[data-rt-set]').forEach(b=>b.setAttribute('aria-pressed',s[b.dataset.rtSet]===b.dataset.value));
const rg=Q(r,'[data-rt-range]');if(rg)rg.value=s.breiteIndex;
const sel=Q(r,'[data-rt-select]');if(sel)sel.value=this.breite;
if(v)this.lp=v.price;
const price=this.money(this.lp||0),label=ok?d.ctaLabel+' · '+price:(v?d.soldOutLabel:d.unavailableLabel),bh=s.raumhoehe?this.bauhoehe(s.raumhoehe):'–';
const note='cm · kleinstes Maß. Abzug 5 mm: Einbauluft.';
const txt={price,widthLabel:String(cm).replace('.',',')+' cm · '+n+' Lamellen',lamellen:n,oberflaeche:s.oberflaeche||'–',
boden:this.lab('boden',s.boden),decke:this.lab('decke',s.decke),element:cm>(+d.splitFrom||300)?'zweiteilig':'einteilig',bauhoehe:bh,note};
QA(r,'[data-rt-txt]').forEach(el=>el.textContent=txt[el.dataset.rtTxt]);
QA(r,'[data-rt-cta]').forEach(b=>{b.disabled=!ok||this.loading;const t=Q(b,'[data-rt-cta-text]');if(t)t.textContent=label;});
const idIn=Q(r,'input[name="id"]');if(idIn){idIn.value=v?v.id:'';idIn.disabled=!ok;}
const p=this.properties();QA(r,'[data-prop]').forEach(i=>i.value=p[i.dataset.prop]||'');
QA(r,'[data-rt-hint]').forEach(hint=>{const k=hint.dataset.rtHint,val=s[k];hint.textContent=(val&&hint.dataset['hint'+val[0].toUpperCase()+val.slice(1)])||'';});
this.drawPreview(cm,n);
const kl=QA(r,'klarna-placement');
if(v&&kl.length){kl.forEach(k=>k.setAttribute('data-purchase-amount',v.price));(window.KlarnaOnsiteService=window.KlarnaOnsiteService||[]).push({eventName:'refresh-placements'});}
if(v&&v.id!=this.uv){
if(pushUrl){const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(history.state,'',u);}
this.uv=v.id;this.syncGallery(v);
}
}
syncGallery(v){
const mid=v.featured_media?.id,g=Q(document,'#Media-Gallery-'+this.d.sectionId);
if(mid&&g?.updateGallery)g.updateGallery(mid,v.options);
pub('variantChange',{data:{sectionId:this.d.sectionId,variant:v}});
this.root.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:{variant:v}}));
}
drawPreview(cm,n){
const svg=Q(this.root,'[data-rt-preview]');if(!svg)return;
svg.innerHTML=this.buildPreview(cm,n,svg.dataset.scene||'wohnzimmer',svg.dataset.person!=='false');
}
/* Massstaebliche Szene: alle Masse in cm, k = px pro cm. Raumhoehe = Eingabe (sonst 250). */
buildPreview(cm,n,scene,person){
const s=this.s,H=s.raumhoehe||250,Wcm=Math.max(520,cm+300),VW=320,top=16,c=this.color||'currentColor';
const k=Math.min(136/H,(VW-24)/Wcm),rw=Wcm*k,x0=(VW-rw)/2,floor=top+H*k;
const X=x=>(x0+x*k).toFixed(1),Y=h=>(floor-h*k).toFixed(1),S=v=>(v*k).toFixed(1);
const R=(x,y,w,h,cls,extra='')=>`<rect x="${X(x)}" y="${Y(y+h)}" width="${S(w)}" height="${S(h)}" class="${cls}"${extra}/>`;
const L=(x1,y1,x2,y2,cls)=>`<line x1="${X(x1)}" y1="${Y(y1)}" x2="${X(x2)}" y2="${Y(y2)}" class="${cls}"/>`;
const divx=(Wcm-cm)/2,left=divx-30,right=Wcm-(divx+cm)-30;
let o=`<rect x="${x0.toFixed(1)}" y="${top}" width="${rw.toFixed(1)}" height="${(H*k).toFixed(1)}" class="rt-pv__wall"/>`;
o+=`<rect x="${x0.toFixed(1)}" y="${floor.toFixed(1)}" width="${rw.toFixed(1)}" height="6" class="rt-pv__floor"/>`;
/* Szene links vom Raumteiler */
if(scene==='wohnzimmer'){
const sw=Math.min(190,left-20);if(sw>90){const sx=divx-20-sw;
o+=R(sx,0,sw,42,'rt-pv__furn')+R(sx,42,sw,38,'rt-pv__furn')+R(sx-6,0,10,64,'rt-pv__furn')+R(sx+sw-4,0,10,64,'rt-pv__furn')+L(sx+sw/2,42,sx+sw/2,80,'rt-pv__edge');
const pw=Math.min(110,sw-20);o+=R(sx+(sw-pw)/2,125,pw,70,'rt-pv__frame')+R(sx+(sw-pw)/2+8,133,pw-16,54,'rt-pv__art');}
if(right>110){const lx=Wcm-45;o+=L(lx,0,lx,150,'rt-pv__edge')+`<path d="M${X(lx-18)} ${Y(150)}h${S(36)}l${S(-8)} ${S(26)}h${S(-20)}z" class="rt-pv__furn"/>`+`<ellipse cx="${X(lx)}" cy="${Y(1)}" rx="${S(14)}" ry="${S(2.5)}" class="rt-pv__furn"/>`;}
}else if(scene==='kueche'){
const kw=Math.min(260,left-20);if(kw>80){const kx=divx-20-kw;
o+=R(kx,0,kw,88,'rt-pv__furn')+R(kx-2,88,kw+4,4,'rt-pv__edge-fill');
for(let x=kx+60;x<kx+kw-10;x+=60)o+=L(x,0,x,88,'rt-pv__edge');
if(H>=225){const uh=Math.min(70,H-150);o+=R(kx,145,kw,uh,'rt-pv__furn');for(let x=kx+60;x<kx+kw-10;x+=60)o+=L(x,145,x,145+uh,'rt-pv__edge');}
o+=L(kx+20,75,kx+40,75,'rt-pv__edge');}
if(right>120){const bx=Wcm-45;o+=`<ellipse cx="${X(bx)}" cy="${Y(75)}" rx="${S(18)}" ry="${S(4)}" class="rt-pv__furn"/>`+L(bx-12,0,bx-6,72,'rt-pv__edge')+L(bx+12,0,bx+6,72,'rt-pv__edge')+L(bx,0,bx,72,'rt-pv__edge');}
}else if(scene==='neutral'){
if(right>110){const dx=divx+cm+40+Math.min(40,right-110);o+=R(dx,0,90,205,'rt-pv__frame')+R(dx+6,0,78,199,'rt-pv__furn')+`<circle cx="${X(dx+70)}" cy="${Y(100)}" r="1.6" class="rt-pv__knob"/>`;}
}
/* Person 175 cm als Massstab */
if(person){let px=divx+cm+60;if(scene==='neutral'||right<90)px=divx-70;if(px<30)px=null;
if(px!==null)o+=`<circle cx="${X(px)}" cy="${Y(164)}" r="${S(11)}" class="rt-pv__person"/>`+`<path d="M${X(px-15)} ${Y(150)}q${S(15)} ${S(-8)} ${S(30)} 0v${S(62)}h${S(-8)}v${S(88)}h${S(-8)}v${S(-88)}h${S(-8)}v${S(88)}h${S(-8)}v${S(-88)}h${S(-8)}z" class="rt-pv__person"/>`;}
/* Raumteiler: Lamellen 3 cm, Raster 8 cm, Leisten oben/unten */
o+=`<rect x="${X(divx)}" y="${top}" width="${S(cm)}" height="${(H*k).toFixed(1)}" class="rt-pv__shadow"/>`;
for(let i=0;i<n;i++)o+=`<rect x="${X(divx+i*8)}" y="${(top+1).toFixed(1)}" width="${Math.max(1.2,3*k).toFixed(1)}" height="${(H*k-2).toFixed(1)}" fill="${c}"/>`;
o+=`<rect x="${X(divx)}" y="${(top+0.5).toFixed(1)}" width="${S(cm)}" height="${Math.max(1.5,2*k).toFixed(1)}" fill="${c}"/><rect x="${X(divx)}" y="${(floor-Math.max(1.5,2*k)-0.5).toFixed(1)}" width="${S(cm)}" height="${Math.max(1.5,2*k).toFixed(1)}" fill="${c}"/>`;
/* Masse */
o+=`<text x="${(x0+4).toFixed(1)}" y="${top-5}" class="rt-pv__text">Raumhöhe ${H} cm</text>`;
o+=`<text x="${X(divx+cm/2)}" y="${(floor+16).toFixed(1)}" text-anchor="middle" class="rt-pv__text rt-pv__text--strong">${cm} cm · ${n} Lamellen</text>`;
if(person)o+=`<text x="${(x0+rw-4).toFixed(1)}" y="${top-5}" text-anchor="end" class="rt-pv__text">Person 175 cm</text>`;
return o;
}
validHoehe(){
const h=Q(this.root,'[data-rt-hoehe]');if(!h)return true; /* Kein Raumhöhen-Block: keine Pflicht */
const v=this.s.raumhoehe;
if(Number.isInteger(v)&&v>=180&&v<=300)return true;
h.setAttribute('aria-invalid','true');h.scrollIntoView({behavior:'smooth',block:'center'});h.focus();
this.showError(this.d.hoeheError);return false;
}
showError(m){const e=Q(this.root,'[data-rt-error]');if(!e)return;e.textContent=m||'';e.hidden=!m;}
async addToCart(btn){
const v=this.variant;if(this.loading||!v||!v.available||!this.validHoehe())return;
this.showError('');this.loading=true;this.render(false);
const dr=Q(document,'#Cart-Drawer'),useDr=dr&&!dr.hasAttribute('data-status-silence'),rt=window.routes||{};
const sec=[{id:'Cart-Icon-Bubble',section:'cart-icon-bubble',selector:'.shopify-section'}];
if(useDr)sec.push({id:'Cart-Drawer',section:dr.dataset.section,selector:'#Cart-Drawer-Details'});
try{
const res=await fetch((rt.cart_add_url||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json'},
body:JSON.stringify({id:v.id,quantity:1,properties:this.properties(),sections:sec.map(x=>x.section).join(','),sections_url:location.pathname})});
const data=await res.json();
if(!res.ok||data.status){this.showError(data.description||data.message||this.d.cartError);return;}
if(typeof SectionDynamicUpdate!=='undefined'&&data.sections)SectionDynamicUpdate.updateSections(sec,data.sections);
pub('cartUpdate',{source:'product-form',productVariantId:v.id,cartData:data});
if(useDr)dr.show(btn);else location.href=rt.cart_url||'/cart';
}catch(e){this.showError(this.d.cartError);}
finally{this.loading=false;this.render(false);}
}
/* Generisches Modal (Individuelle Anfrage): Scroll-Lock + Fokusfalle ueber global.js */
openModal(op){
const m=document.getElementById(op.dataset.rtOpenModal);if(!m)return;
this.modal=m;this.modalOp=op;m.hidden=false;this.fillConfig(m);
fn('disablePageScroll');fn('trapFocus',Q(m,'[data-trap]'),Q(m,'textarea')||Q(m,'[data-rt-modal-close]'));
}
closeModal(){const m=this.modal;if(!m||m.hidden)return;m.hidden=true;fn('enablePageScroll');fn('removeTrapFocus',this.modalOp);}
configText(){
const s=this.s,p=[];
if(s.oberflaeche)p.push('Oberfläche: '+s.oberflaeche);
p.push('Breite: '+String(+this.breite/10).replace('.',',')+' cm ('+LAM(+this.breite)+' Lamellen)');
if(s.raumhoehe)p.push('Raumhöhe: '+s.raumhoehe+' cm');
p.push('Boden: '+this.lab('boden',s.boden)+', Decke: '+this.lab('decke',s.decke));
return p.join(' · ');
}
fillConfig(m){const c=Q(m,'[data-rt-anfrage-config]');if(c)c.textContent=(c.dataset.prefix||'')+this.configText();}
anfrageBody(a){
const m=a.closest('[data-rt-modal]'),ta=m&&Q(m,'[data-rt-anfrage-text]'),txt=ta?ta.value.trim():'';
return(txt?txt+'\n\n':'')+'Produkt: '+(this.d.productTitle||'')+'\n'+this.configText()+'\n'+location.href.split('?')[0];
}
buildMail(a){a.href='mailto:'+a.dataset.mail+'?subject='+encodeURIComponent(a.dataset.subject||'Anfrage')+'&body='+encodeURIComponent(this.anfrageBody(a));}
buildWa(a){a.href='https://wa.me/'+a.dataset.wa+'?text='+encodeURIComponent(this.anfrageBody(a));}
openCheck(op){
const d=this.dlg;if(!d)return;this.op=op;d.hidden=false;this.step(1);
const first=Q(d,'[data-rt-dlg="close"]');fn('disablePageScroll');fn('trapFocus',Q(d,'[data-trap]'),first);
}
closeCheck(){
const d=this.dlg;if(!d||d.hidden)return;d.hidden=true;fn('enablePageScroll');
fn('removeTrapFocus',this.op);
}
val(n,l){const i=Q(this.dlg,`input[name="${n}"]:checked`);return i?(l&&i.dataset.short)||i.value:'';}
hoehen(){return['l','r','m'].map(k=>+Q(this.dlg,`[name="rt-h-${k}"]`).value||NaN);}
markOpts(){QA(this.dlg,'.rt-opt input').forEach(i=>i.closest('.rt-opt').classList.toggle('is-checked',i.checked));}
step(n){
const d=this.dlg;this.cs=n;
QA(d,'[data-rt-step]').forEach(el=>el.hidden=el.dataset.rtStep!=n);
QA(d,'[data-rt-progress] span').forEach((el,i)=>{el.classList.toggle('is-on',i<n);el.classList.toggle('is-current',i===n-1);});
this.markOpts();
Q(d,'[data-rt-fbh-pref]').hidden=this.val('rt-fbh')!=='nein';
Q(d,'[data-rt-dlg-error]').hidden=true;
Q(d,'[data-rt-step-label]').textContent=n<4?'Schritt '+n+' von 3':'Ergebnis';
}
dialogAction(a){
const d=this.dlg,n=this.cs,t=d.dataset;
if(a==='close')return this.closeCheck();if(a==='back')return this.step(n-1);if(a==='apply')return this.applyCheck();
let m='';
if(n===1){const f=this.val('rt-fbh');if(!f||!this.val('rt-belag')||(f==='nein'&&!this.val('rt-fbh-pref')))m=t.errStep;}
if(n===2&&(!this.val('rt-decke-pref')||!this.val('rt-deckenart')))m=t.errStep;
if(n===3&&this.hoehen().some(x=>!Number.isInteger(x)||x<180||x>300))m=t.errHoehe;
const e=Q(d,'[data-rt-dlg-error]');if(m){e.textContent=m;e.hidden=false;return;}
if(n===3){this.check=this.computeCheck();this.renderResult(this.check);}
this.step(n+1);
}
computeCheck(){
const t=this.dlg.dataset,fbh=this.val('rt-fbh'),pref=this.val('rt-fbh-pref'),belag=this.val('rt-belag'),dpref=this.val('rt-decke-pref'),dart=this.val('rt-deckenart');
const hs=this.hoehen(),min=Math.min(...hs),max=Math.max(...hs),why=[],hints=[];
let boden=fbh==='nein'?pref:'kleben';
if(belag==='teppich'){boden='schrauben';why.push(t.whyTeppich);if(fbh!=='nein')hints.push(t.hintTeppichFbh);}
else if(fbh==='ja')why.push(t.whyFbhJa);else if(fbh==='unsicher')why.push(t.whyFbhUnsicher);else why.push(pref==='kleben'?t.whyPrefKleben:t.whyPrefSchrauben);
if(belag==='parkett'&&boden==='kleben')hints.push(t.hintParkett);
why.push(dpref==='kleben'?t.whyDeckeKleben:t.whyDeckeSchrauben);
if(dart==='gipskarton')hints.push(t.hintGipskarton);if(dart==='unsicher')hints.push(t.hintDeckeUnsicher);
if(max>min)hints.push(t.hintAbweichung.replace('[cm]',max-min));
return{fbh,belag,pref:pref||null,dpref,dart,hoehen:hs,min,boden,decke:dpref,why,hints,
summary:`FBH: ${this.val('rt-fbh',1)} · Belag: ${this.val('rt-belag',1)} · Decke: ${this.val('rt-deckenart',1)} · Maße: ${hs.join('/')}`};
}
renderResult(c){
const d=this.dlg,li=x=>`<li>${x}</li>`;
Q(d,'[data-rt-result-text]').textContent=`Boden ${this.lab('boden',c.boden)} · Decke ${this.lab('decke',c.decke)} · Bauhöhe ${this.bauhoehe(c.min,c.boden,c.decke)}`;
Q(d,'[data-rt-result-why]').innerHTML=c.why.map(li).join('');
const h=Q(d,'[data-rt-result-hints]');h.innerHTML=c.hints.map(li).join('');h.parentElement.hidden=!c.hints.length;
}
applyCheck(){
const c=this.check;if(!c)return;
Object.assign(this.s,{boden:c.boden,decke:c.decke,raumhoehe:c.min,check:c});
const h=Q(this.root,'[data-rt-hoehe]');if(h)h.value=c.min;
const panel=Q(this.root,'[data-rt-check-panel]');if(panel)panel.classList.add('is-done');
this.closeCheck();this.render();
const b=Q(this.root,'[data-rt-bef="boden"]');if(b)b.scrollIntoView({behavior:'smooth',block:'start'});
}
}
const boot=()=>QA(document,'[data-rt-konfigurator]:not([data-rt-ready])').forEach(el=>{el.setAttribute('data-rt-ready','1');new Rt(el);});
boot();document.addEventListener('shopify:section:load',boot);
